"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaDisplayItem = void 0;
var react_1 = __importDefault(require("react"));
var item_1 = require("./item");
var value_1 = require("./value");
/**
 * Renders a singular display item given the schema, values, and property key name
 * @param props
 */
function SchemaDisplayItem(props) {
    var name = props.name, schema = props.schema, values = props.values;
    var field = (schema.properties || {})[name];
    // When there is no type it means it is a hidden field.
    if (!(field === null || field === void 0 ? void 0 : field.inputType))
        return null;
    return react_1.default.createElement(item_1.DisplayItem, { name: name, field: field, value: values[name] });
}
exports.SchemaDisplayItem = SchemaDisplayItem;
/**
 * Allows to extend Value by adding new inputType handlers
 * @param inputType
 * @param customValue
 */
SchemaDisplayItem.registerComponent = function (inputType, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
customValue, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
getStringifiedFieldValue) {
    value_1.Value.registerComponent(inputType, customValue, getStringifiedFieldValue);
};
